import { render, staticRenderFns } from "./ManageDeals.vue?vue&type=template&id=60c303bb&scoped=true"
import script from "./ManageDeals.vue?vue&type=script&lang=js"
export * from "./ManageDeals.vue?vue&type=script&lang=js"
import style0 from "./ManageDeals.vue?vue&type=style&index=0&id=60c303bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c303bb",
  null
  
)

export default component.exports